<template src="./single-issue.html">
</template>
<script>
  import Vue from 'vue'
  import Loader from '@/components/misc/Loader'
  import ContextHeader from '@/components/misc/context-header/ContextHeader'
  import { hasIssueResolveClaim } from '@/router/auth'
  import { EventBus } from '@/router/bus'
  import { getAccessToken } from '@/utils/cookie'

  export default {
    name: 'single-issue',
    components: {
      Loader,
      ContextHeader
    },
    data () {
      return {
        load: false,
        IssueStatus: {
          ACTIVE: 1,
          CANCELLED: 2,
          RESOLVED: 3,
          UNRESOLVED: 4
        },
        issueReport: {},
        issueUser: {},
        issueId: this.$route.params.issueId,
        hasInvoiceCancelClaim: false,
        resolveOptions: [
            { text: this.$t('issues.reportIssueResolved'), value: 3 },
            { text: this.$t('issues.reportIssueUnresolved'), value: 4 }
        ],
        resolveStatus: 3,
        resolveComment: null,
        resourceLink: '',
        formattedNotificationTypes: null,
        selectedNotificationTypes: [],
        sinks: {
          Email: 1
        }
      }
    },
    computed: {
      issueActive () {
        return this.issueReport.status === this.IssueStatus.ACTIVE
      },
      issueCancelled () {
        return this.issueReport.status === this.IssueStatus.CANCELLED
      },
      issueResolved () {
        return this.issueReport.status === this.IssueStatus.RESOLVED
      },
      issueUnresolved () {
        return this.issueReport.status === this.IssueStatus.UNRESOLVED
      },
      isDevelopment () {
        return !this.isProductionEnvironment()
      }
    },
    created: function () {
      this.hasIssueResolveClaim = hasIssueResolveClaim()

      this.loadIssue()
    },
    methods: {
      loadIssue () {
        this.load = true
        Vue.http.headers.common['Authorization'] = 'Bearer ' + getAccessToken()
        this.$http.get(Vue.$apiConfig.issueReportGet + '/' + this.issueId)
          .then(response => {
            this.logConsole(response)
            let issue = response.data.payload
            this.issueReport = issue.issueReport
            this.issueUser = issue.user

            if (this.issueReport.resourceId.startsWith('i')) {
              this.resourceLink = '/group-settlement/' + this.issueReport.resourceId
            } else {
              this.resourceLink = '/invoices/' + this.issueReport.resourceId
            }
            this.load = false
          }, error => {
            this.formatErrorResponse(error)
            this.logConsole(error)
            this.load = false
          })
      },
      cancelIssueReport () {
        this.logConsole('Cancelling issue report')
        this.load = true
        this.issueReport.organizationId = null
        this.$http.post(Vue.$apiConfig.issueReportCancelPost, this.issueReport)
          .then(response => {
            this.logConsole(response)
            this.load = false
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('issues.reportIssueCancelSuccess'),
              errors: []
            })
            this.$nextTick(function () {
              this.issueReport.status = this.IssueStatus.CANCELLED
            })
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      resolveIssueReport () {
        this.logConsole('Resolving issue report')
        var issueResolveObject = Object.assign({}, this.issueReport)
        issueResolveObject.status = this.resolveStatus
        issueResolveObject.operatorComment = this.resolveComment
        this.load = true
        this.$http.post(Vue.$apiConfig.issueReportResolvePost, issueResolveObject)
          .then(response => {
            this.logConsole(response)
            this.load = false
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('issues.reportIssueResolveSuccess'),
              errors: []
            })
            this.$nextTick(function () {
              this.issueReport.status = this.resolveStatus
              this.issueReport.operatorComment = this.resolveComment
            })
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      submitNotificationSubscription () {
        this.subscribeToSelectedNotificationTypes()
      },
      subscribeToEmailSink () {
        this.$http.post(Vue.$config.notification_api_root + '/' + Vue.$apiConfig.sinksSubscribe, {sinks: [this.sinks.Email]})
          .then(response => {
            this.logConsole(response)
          }, error => {
            this.logConsole(error)
          })
      },
      subscribeToSelectedNotificationTypes () {
        this.$http.post(Vue.$config.notification_api_root + '/' + Vue.$apiConfig.notificationSubcribe, {notificationTypes: this.selectedNotificationTypes, resourceId: this.issueId, resourceType: Vue.$config.issueResourceType})
          .then(response => {
            this.logConsole(response)
            this.subscribeToEmailSink()
            this.load = false
            if (this.selectedNotificationTypes.length > 0) {
              EventBus.$emit('alert', {
                variant: 'success',
                message: this.$t('notifications.subscribedIssueSuccessfully'),
                errors: []
              })
            } else {
              EventBus.$emit('alert', {
                variant: 'success',
                message: this.$t('notifications.unsubscribedIssueSuccessfully'),
                errors: []
              })
            }
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      subscribeToNotification () {
        this.$refs.subscribeToNotification.show()
        this.$http.get(Vue.$config.notification_api_root + '/' + Vue.$apiConfig.notificationTypes + '?resourceId=' + this.issueReport.id + '&resourceType=' + Vue.$config.issueResourceType)
          .then(response => {
            this.formatNotificationTypes(response.data.payload)
            this.logConsole(response)
            this.load = false
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      formatNotificationTypes (notificationTypes) {
        this.formattedNotificationTypes = []
        this.selectedNotificationTypes = []
        for (let i = 0; i < notificationTypes.length; i++) {
          let notificationType = {
            text: notificationTypes[i].name,
            value: notificationTypes[i].notificationTypeId
          }
          this.formattedNotificationTypes.push(notificationType)
          if (notificationTypes[i].subscribed) {
            this.selectedNotificationTypes.push(notificationType.value)
          }
        }
      }
    }
  }

</script>

<style lang="scss" type="text/scss" scoped>

  @import '~@/assets/scss/variables.scss';

  .bg-primary {
    background-color: $primary-color-accent !important;
  }
  
  .text-dark {
    font-weight: 600;
    font-size: 12pt;
    color: $font-color-dark !important;
  }
  
  #cancelInvoiceModal {
    margin-top: 60px;
  }

  .property-label {
    font-size: 11pt;
    font-weight: 400;
  }

  .property-label-caption {
    font-size: 12pt;
    font-weight: 600;
  }

  .full-width {
    width: 100%;
  }  

  .issue-cancelled-card {
    background-color: transparentize($background-color-danger, .9) !important;
  }

  .issue-resolved-card {
    background-color: transparentize($background-color-success, .9) !important;
  }

  .issue-unresolved-card {
    background-color: transparentize($background-color-warning, .9) !important;
  }

  .report-image {
    cursor: pointer;
     width: 36px;
     height: 36px;
  }

</style>



// WEBPACK FOOTER //
// SingleIssue.vue?033338f8